/**
 * Organisation identity — the hospital that owns this LMS.
 * The Emergency Department owns and runs the platform (and is its heaviest user),
 * so it stays prominent across certificates and chrome. Single source of truth:
 * change the name here and it updates everywhere.
 */
export const ORG = {
  hospital: { en: 'Bangbuatong Hospital', th: 'โรงพยาบาลบางบัวทอง' },
  owner: { en: 'Emergency Department', th: 'แผนกฉุกเฉิน' },
  /**
   * Certifying authority who co-signs EVERY certificate (the second signature
   * block, alongside the per-course instructor). Set the real name + role per
   * deployment — this is the single source of truth.
   */
  certifier: { name: 'Dr. Anan Phongphan', role: 'Head, Emergency Department' },
} as const;
